import { system } from "@smart/bridge-types-basic";
import { buildAssetBucketDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";

const IntakeUploadedFilesNS = buildNamespace({
  system,
  entity: "IntakeUploadedFiles",
} as const);

export const IntakeUploadedFilesDef = buildAssetBucketDef({
  cdn: false,
  prefix: "intakeUploadedFiles",
  namespace: IntakeUploadedFilesNS,
});
